/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

// IMPORTANT: Install network interceptor BEFORE anything that may trigger fetch/XHR.
// The API Inspector captures every request only if patching happens first.
// Vite replaces FF_DEV_COCKPIT with "" in production, making the call
// dead code. Rollup then tree-shakes the unused import and its dependencies.
import { installGlobalFetchInterceptor } from "./features/dev-cockpit/services/global-network-interceptor";
if (import.meta.env.FF_DEV_COCKPIT === 'true') {
  installGlobalFetchInterceptor();
}

// IMPORTANT: Initialize logger to control console output based on REACT_APP_DEBUG
// This ensures no logging in production environments
import { initializeLogger } from "./shared/utils/logger";
initializeLogger();

// IMPORTANT: Initialize storage wrappers BEFORE any other imports that use storage
// This ensures all code (including OIDC, i18n, etc.) respects CDU consent
import { initializeLocalStorageWrapper } from "./shared/utils/storage/localStorageWrapper";
import { initializeSessionStorageWrapper } from "./shared/utils/storage/sessionStorageWrapper";
import { initializeCookieStoreWrapper } from "./shared/utils/storage/cookieStoreWrapper";
initializeLocalStorageWrapper();
initializeSessionStorageWrapper();
initializeCookieStoreWrapper();

import ReactDOM from "react-dom/client";
import "./shared/styles/index.css";
import "./shared/i18n"; // Initialize i18n
import { validateRequiredEnvVars } from "./shared/utils/validate-env";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router/dom";
import { captureReferralCode } from "@shared/utils/referral-storage";
import { router } from "./router";

// Capture referral code from URL immediately, before React mounts.
// This guarantees ?ref= is persisted even if OIDC redirects or StepsProvider
// rewrites the URL before any React component can read it.
captureReferralCode();

// Validate required environment variables before rendering the app
validateRequiredEnvVars();

// Theme initialization is now handled in UIProvider

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <RouterProvider router={router} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
